import BrowserTab from "./BrowserTab";
import HiringPortal from "./HiringPortal";
import googleLogo from "./assets/googlel.svg";

export function GoogleAuthFooter() {
  return (
    <footer className="google-signin-footer">
      <span className="google-signin-lang">English (United States)</span>
      <nav className="google-signin-footer-nav" aria-label="Google footer">
        <a href="#help">Help</a>
        <a href="#privacy">Privacy</a>
        <a href="#terms">Terms</a>
      </nav>
    </footer>
  );
}

export function GoogleAccountChip({ email, onClick }) {
  const className = "google-signin-account-chip";

  const chevron = (
    <svg
      className="google-signin-account-chevron"
      width="10"
      height="6"
      viewBox="0 0 10 6"
      aria-hidden="true"
    >
      <path
        d="M1 1l4 4 4-4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (onClick) {
    return (
      <button type="button" className={className} onClick={onClick}>
        <span className="google-signin-account-email">{email}</span>
        {chevron}
      </button>
    );
  }

  return (
    <div className={className}>
      <span className="google-signin-account-email">{email}</span>
      {chevron}
    </div>
  );
}

export default function GoogleAuthPopup({ children }) {
  return (
    <div className="calendly-back">
      <HiringPortal interactive={false} />
      <div className="login-page">
        <div className="browser-shadow google-signin-window google-verify-window">
          <BrowserTab />
          <div className="login-container google-signin-body google-verify-body">
            <div className="google-signin-brand-row">
              <img
                src={googleLogo}
                alt="Google"
                className="google-signin-mark"
              />
            </div>
            <div className="google-verify-main">{children}</div>
            <GoogleAuthFooter />
          </div>
        </div>
      </div>
    </div>
  );
}
